import {
  addZipCodeMask,
  convertEventSelectToTarget,
  DataTable,
  formatDataToLabelValue,
  FormFeedBack,
  ModalConfirmAction,
  OverlineTitle,
  PROFILE_URL_PATH,
  Select,
  SelectRemote,
  STATUSPAGE,
} from '@repo/ui';
import { CpfInput, TelPhone } from 'adasi_components';
import { getProfileTypeFromName } from 'domain/value-objects/profile-type';
import { useProfession } from 'presentation/app/hooks/useProfession';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { clearCitiesForSelectOptionsData } from 'presentation/config/store/cities/cities-slice';
import { clearProfessionalManagementById } from 'presentation/config/store/professionals/profissional-management-slice';
import { clearProfilesAssociated } from 'presentation/config/store/users/users-associated-slice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Card, Col, Form, Input, Label, Row } from 'reactstrap';

import noDataBg from '../../../../assets/images/no-task.png';
import { makeColumnsCoordinators } from '../../Coordinators/common/columns/coordinators-columns';
import { useProfessionalManagement } from '../../hooks/useProfissionalManagement';

// optionsSelect
const optionsGender = [
  {
    value: 'M',
    label: 'Masculino',
  },
  {
    value: 'F',
    label: 'Feminino',
  },
];

export const ProfessionalManagementForm = () => {
  //hooks
  const dispatch = useDispatch();
  const { professionalType, id } = useParams<{
    professionalType: PROFILE_URL_PATH;
    id: string;
  }>();

  const { professionList, setProfessionList, requestGetProfession } =
    useProfession();

  const { citiesForSelectOptionsData } = useAppSelector(
    (state) => state.citiesForSelect,
  );
  const { profilesAssociated } = useAppSelector(
    (state) => state.usersAssociatedSlice,
  );

  const {
    validation,
    searchCityInputLoading,
    profileAssociateId,
    profileStatus,
    roleId,
    isModalOpen,
    profilesLoading,
    setProfilesLoading,
    setProfileStatus,
    setProfileId,
    requestGetAddressViaZipCode,
    requestGetAllCitiesForSelectOptions,
    handleGetByIdProfessionalManagement,
    requestGetAllProfilesAssociated,
    requestUpdateStatusAssociatePersonProfile,
    toggleModalActivateInactiveProfile,
    handleActiveInactiveSwitchChangeProfile,
  } = useProfessionalManagement();

  useEffect(() => {
    if (!id || !professionalType) return;

    dispatch(clearProfilesAssociated());
    setProfilesLoading(true);

    requestGetAllProfilesAssociated({
      id,
      profileType: getProfileTypeFromName(professionalType),
    }).finally(() => {
      setProfilesLoading(false);
    });
  }, [id, professionalType]);

  //useEffect
  useEffect(() => {
    id &&
      handleGetByIdProfessionalManagement({
        id,
        professionalType: getProfileTypeFromName(professionalType),
      });

    return () => {
      dispatch(clearProfessionalManagementById());
    };
  }, []);

  return (
    <div>
      {/* <Container fluid> */}
      {/* <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Dados Cadastrais</h4>
          <Button
            color="link"
            className="text-decoration-underline"
            onClick={() => navigate(`/equipe/${professionalType}`)}
          >
            <i className="ri-arrow-left-line"></i>
            Voltar
          </Button>
        </div> */}
      <Row>
        {/* {id ? (
            <Col xxl={3}>
              <ProfessionalBasicInfoCard
                professional={professionalManagementByIdResponse}
              >
                <ProfessionalManagementLinks
                  id={id}
                  pathname={pathname}
                  professionalType={professionalType}
                  navigate={navigate}
                />
              </ProfessionalBasicInfoCard>
            </Col>
          ) : null} */}

        <Col className="mt-5">
          <Form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Card className="p-3">
              <Row>
                <div>
                  <OverlineTitle title="Dados Básicos" />
                </div>
                <Col md={3} className="mt-3">
                  <Label htmlFor="cpf" className="form-label">
                    CPF
                  </Label>
                  <CpfInput
                    disabled
                    name="cpf"
                    inputId="cpf"
                    className="form-control"
                    value={validation.values.cpf}
                    onBlur={validation.handleBlur}
                    handleChange={validation.handleChange}
                    invalid={
                      !!(validation.touched.cpf && validation.errors.cpf)
                    }
                  />
                  <FormFeedBack
                    error={validation.errors?.cpf}
                    isInvalid={
                      !!(validation.touched.cpf && validation.errors?.cpf)
                    }
                  />
                </Col>
                <Col md={9} className="mt-3">
                  <Label htmlFor="name" className="form-label">
                    Nome Completo
                  </Label>
                  <Input
                    disabled
                    name="name"
                    className="form-control"
                    value={validation.values.name}
                    onChange={validation.handleChange}
                    invalid={
                      !!(validation.touched.name && validation.errors.name)
                    }
                  />
                  <FormFeedBack
                    error={validation.errors?.name}
                    isInvalid={
                      !!(validation.touched.name && validation.errors?.name)
                    }
                  />
                </Col>

                <Col md={6} className="mt-3">
                  <Label htmlFor="socialName" className="form-label">
                    Nome Social
                  </Label>
                  <Input
                    disabled
                    name="socialName"
                    className="form-control"
                    value={validation.values.socialName}
                    onChange={validation.handleChange}
                  />
                </Col>
                <Col className="mt-3" md={3}>
                  <Label htmlFor="gender" className="form-label">
                    Sexo
                  </Label>
                  <Select
                    isDisabled
                    isClearable
                    id="gender"
                    name="gender"
                    placeholder=""
                    options={optionsGender}
                    onBlur={validation.handleBlur}
                    value={validation?.values?.gender}
                    onChange={(e) => {
                      validation.handleChange(
                        convertEventSelectToTarget('gender', e),
                      );
                    }}
                    invalid={
                      !!(
                        validation?.touched?.gender &&
                        validation?.errors?.gender
                      )
                    }
                  />
                  {validation?.touched?.gender?.value &&
                  validation?.errors?.gender?.value ? (
                    <FormFeedBack
                      error={validation?.errors?.gender?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched?.gender &&
                          validation?.errors?.gender
                        )
                      }
                    />
                  ) : null}
                </Col>
                <Col md={3} className="mt-3">
                  <Label htmlFor="birthDate" className="form-label">
                    Nascimento
                  </Label>
                  <Input
                    disabled
                    type="date"
                    name="birthDate"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.birthDate}
                    invalid={
                      !!(
                        validation.touched.birthDate &&
                        validation.errors?.birthDate
                      )
                    }
                  />
                  {validation.touched.birthDate &&
                  validation.errors?.birthDate ? (
                    <FormFeedBack
                      error={validation?.errors?.birthDate?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.birthDate &&
                          validation?.errors?.birthDate
                        )
                      }
                    />
                  ) : null}
                </Col>

                <Col md={6} className="mt-3">
                  <Label htmlFor="profession" className="form-label">
                    Profissão
                  </Label>

                  <SelectRemote
                    isDisabled
                    name="profession"
                    clearOptions={() =>
                      dispatch(clearCitiesForSelectOptionsData())
                    }
                    functionSearch={(searchString) => {
                      if (searchString.length === 0) {
                        setProfessionList(null);
                        return;
                      }
                      if (searchString.length < 3) return;

                      requestGetProfession({ query: searchString });
                    }}
                    inputId={'profession'}
                    onChange={(e) => {
                      validation.handleChange(
                        convertEventSelectToTarget('profession', e),
                      );
                    }}
                    onBlur={validation.handleBlur}
                    options={formatDataToLabelValue(
                      professionList as never,
                      'id',
                      'name',
                    )}
                    value={validation?.values?.profession}
                    loading={searchCityInputLoading === STATUSPAGE.LOADING}
                  />
                </Col>

                <Col md={3} className="mt-3">
                  <Label htmlFor="professionalCouncil" className="form-label">
                    Conselho Profissional
                  </Label>
                  <Input
                    disabled
                    type="text"
                    className="form-control"
                    name="professionalCouncil"
                    onChange={validation.handleChange}
                    value={validation.values.professionalCouncil}
                  />
                </Col>

                <div className="mt-4">
                  <OverlineTitle title="Contato" />
                </div>
                <Col className="mt-3" sm={6} lg={3} xl={3}>
                  <Label htmlFor="phone">Telefone</Label>
                  <TelPhone
                    disabled
                    id="phone"
                    name="phone"
                    value={`${validation.values.phone}`}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      if (e) {
                        const inputValue = {
                          target: {
                            name: 'phone',
                            value: e,
                          },
                        };
                        validation.handleChange(inputValue);
                      }
                    }}
                    onBlur={validation.handleBlur}
                    invalid={
                      !!(validation.touched.phone && validation.errors?.phone)
                    }
                  />
                  {validation.touched.phone && validation.errors?.phone ? (
                    <FormFeedBack
                      error={validation?.errors?.phone?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.phone && validation?.errors?.phone
                        )
                      }
                    />
                  ) : null}
                </Col>
                <Col md={3} className="mt-3">
                  <Label htmlFor="email" className="form-label">
                    Email
                  </Label>
                  <Input
                    disabled
                    name="email"
                    type="email"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    onChange={validation.handleChange}
                    invalid={
                      !!(validation.touched.email && validation.errors?.email)
                    }
                  />
                  {validation.touched.email && validation.errors?.email ? (
                    <FormFeedBack
                      error={validation?.errors?.email?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.email && validation?.errors?.email
                        )
                      }
                    />
                  ) : null}
                </Col>

                <div className="my-4">
                  <OverlineTitle title="Endereço" />
                </div>

                <Col sm={3} lg={2} xl={3} className="mb-3">
                  <Label htmlFor="zipcode">CEP</Label>
                  <Input
                    disabled
                    type="text"
                    id="zipcode"
                    name="zipcode"
                    maxLength={8}
                    onChange={(e) => {
                      validation.handleChange(e);
                    }}
                    onBlur={(e) => {
                      requestGetAddressViaZipCode({
                        zipCode: e.target.value,
                      });

                      validation.handleBlur;
                    }}
                    value={addZipCodeMask(validation.values.zipcode)}
                    // disabled={
                    //   searchZipCodeInputLoading === STATUSPAGE.LOADING
                    // }
                    invalid={
                      !!(
                        validation.touched.zipcode && validation.errors?.zipcode
                      )
                    }
                  />
                  {validation.touched.zipcode && validation.errors?.zipcode ? (
                    <FormFeedBack
                      error={validation?.errors?.zipcode?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.zipcode &&
                          validation?.errors?.zipcode
                        )
                      }
                    />
                  ) : null}
                </Col>

                <Col md={6} className="mb-3">
                  <Label htmlFor="street" className="form-label">
                    Logradouro
                  </Label>
                  <Input
                    disabled
                    type="text"
                    name="street"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    value={validation.values.street}
                    onChange={validation.handleChange}
                    invalid={
                      !!(validation.touched.street && validation.errors?.street)
                    }
                  />
                  {validation.touched.street && validation.errors?.street ? (
                    <FormFeedBack
                      error={validation?.errors?.street?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.street &&
                          validation?.errors?.street
                        )
                      }
                    />
                  ) : null}
                </Col>
                <Col md={3}>
                  <Label htmlFor="addressNumber" className="form-label">
                    Número
                  </Label>
                  <Input
                    disabled
                    type="text"
                    name="addressNumber"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    value={validation.values.addressNumber}
                    onChange={validation.handleChange}
                    invalid={
                      !!(
                        validation.touched.addressNumber &&
                        validation.errors?.addressNumber
                      )
                    }
                  />
                  {validation.touched.addressNumber &&
                  validation.errors?.addressNumber ? (
                    <FormFeedBack
                      error={validation?.errors?.addressNumber?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.addressNumber &&
                          validation?.errors?.addressNumber
                        )
                      }
                    />
                  ) : null}
                </Col>

                <Col className="mt-3" md={5}>
                  <Label htmlFor="addressComplement" className="form-label">
                    Complemento
                  </Label>
                  <Input
                    disabled
                    type="text"
                    name="addressComplement"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.addressComplement}
                  />
                </Col>

                <Col className="mt-3" md={3}>
                  <Label htmlFor="district" className="form-label">
                    Bairro
                  </Label>
                  <Input
                    disabled
                    type="text"
                    name="district"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    value={validation.values.district}
                    onChange={validation.handleChange}
                    invalid={
                      !!(
                        validation.touched.district &&
                        validation.errors?.district
                      )
                    }
                  />
                  {validation.touched.district &&
                  validation.errors?.district ? (
                    <FormFeedBack
                      error={validation?.errors?.district?.toString()}
                      isInvalid={
                        !!(
                          validation?.touched.district &&
                          validation?.errors?.district
                        )
                      }
                    />
                  ) : null}
                </Col>

                <Col className="mt-3" md={4}>
                  <Label htmlFor="city" className="form-label">
                    Cidade
                  </Label>
                  <SelectRemote
                    isDisabled
                    name="city"
                    clearOptions={() =>
                      dispatch(clearCitiesForSelectOptionsData())
                    }
                    functionSearch={(searchString) => {
                      if (searchString.length === 0) {
                        dispatch(clearCitiesForSelectOptionsData());
                        return;
                      }
                      if (searchString.length < 3) return;
                      requestGetAllCitiesForSelectOptions({
                        search: searchString,
                      });
                    }}
                    inputId={'city'}
                    onChange={(e) => {
                      validation.handleChange(
                        convertEventSelectToTarget('city', e),
                      );
                    }}
                    onBlur={validation.handleBlur}
                    options={formatDataToLabelValue(
                      citiesForSelectOptionsData as never,
                      'id',
                      'name',
                    )}
                    value={validation.values.city as any}
                    // isDisabled={
                    //   searchZipCodeInputLoading === STATUSPAGE.LOADING
                    // }
                    loading={searchCityInputLoading === STATUSPAGE.LOADING}
                  />
                </Col>
                {/* {currentUser?.activeProfile?.profileId !==
                    PERSON_TYPE.DIRECTOR && (
                    <>
                      <div className="my-4">
                        <OverlineTitle title="Detalhes Contratuais" />
                      </div>

                      <Col md={2}>
                        <Label
                          htmlFor="hasAccessToTimeControl"
                          className="form-label"
                        >
                          Controle de pontos
                        </Label>
                        <Select
                          isDisabled
                          isClearable
                          id="hasAccessToTimeControl"
                          name="hasAccessToTimeControl"
                          options={[
                            {
                              label: 'Sim',
                              value: true,
                            },
                            {
                              label: 'Não',
                              value: false,
                            },
                          ]}
                          placeholder=""
                          onBlur={validation.handleBlur}
                          value={validation?.values?.hasAccessToTimeControl}
                          onChange={(e) => {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'hasAccessToTimeControl',
                                e,
                              ),
                            );
                          }}
                        />
                      </Col>

                      <Col md={2}>
                        <Label htmlFor="employmentMode" className="form-label">
                          Modalidade de Vinculo
                        </Label>
                        <Select
                          isDisabled
                          isClearable
                          id="employmentMode"
                          name="employmentMode"
                          options={optionsEmploymentMode}
                          placeholder=""
                          onBlur={validation.handleBlur}
                          value={validation?.values?.employmentMode}
                          onChange={(e) => {
                            validation.handleChange(
                              convertEventSelectToTarget('employmentMode', e),
                            );
                          }}
                        />
                      </Col>

                      <Col md={2}>
                        <Label htmlFor="weekWorkload" className="form-label">
                          CH Semanal
                        </Label>
                        <Input
                          disabled
                          name="weekWorkload"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          value={validation.values.weekWorkload}
                        />
                      </Col>

                      <Col md={2}>
                        <Label htmlFor="valueHour" className="form-label">
                          Valor hora
                        </Label>
                        <CurrencyInput
                          disabled
                          id="valueHour"
                          name="valueHour"
                          className="form-control"
                          value={validation.values.valueHour}
                          onChange={validation.handleChange}
                          defaultValue={1000}
                          decimalsLimit={2}
                        />
                      </Col>

                      <Col md={2}>
                        <Label htmlFor="validity" className="form-label">
                          Vigência
                        </Label>
                        <MonthYearDatePicker
                          validation={validation}
                          fieldName="validity"
                        />
                      </Col>

                      <Col md={2}>
                        <Label htmlFor="manager" className="form-label">
                          Gestor
                        </Label>
                        <Select
                          isDisabled
                          isClearable
                          id="manager"
                          name="manager"
                          options={[
                            {
                              label: 'Sim',
                              value: true,
                            },
                            {
                              label: 'Não',
                              value: false,
                            },
                          ]}
                          placeholder=""
                          onBlur={validation.handleBlur}
                          value={validation?.values?.manager}
                          onChange={(e) => {
                            validation.handleChange(
                              convertEventSelectToTarget('manager', e),
                            );
                          }}
                        />
                      </Col>
                      <div className="my-4">
                        <OverlineTitle title="Preferência" />
                      </div>

                      <Col md={3}>
                        <Label htmlFor="setNewPass" className="form-label">
                          Definir Nova
                        </Label>
                        <Input
                          disabled
                          name="setNewPass"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          value={validation.values.setNewPass}
                        />
                      </Col>

                      <Col md={2}>
                        <Label htmlFor="isActive" className="form-label">
                          Cadastro Ativo
                        </Label>
                        <Select
                          isDisabled
                          isClearable
                          id="isActive"
                          name="isActive"
                          placeholder=""
                          options={[
                            {
                              label: 'Sim',
                              value: true,
                            },
                            {
                              label: 'Não',
                              value: false,
                            },
                          ]}
                          onBlur={validation.handleBlur}
                          value={validation?.values?.isActive}
                          onChange={(e) => {
                            validation.handleChange(
                              convertEventSelectToTarget('isActive', e),
                            );
                          }}
                        />
                      </Col>
                      {id && (
                        <Col>
                          <Label htmlFor="isActive" className="form-label">
                            Curso
                          </Label>
                          <p className="text-muted">
                            {professionalManagementByIdResponse?.courseName}
                          </p>
                        </Col>
                      )}
                    </>
                  )} */}
                {/*  */}
              </Row>

              {/* <CardFooter className="pe-0 mt-5 pb-0">
                  <Row className="d-flex justify-content-end align-items-center">
                    <Col xs="2" md="2">
                      <div className="form-group d-flex justify-content-end align-items-center">
                        <Button
                          onClick={() => {
                            navigate(`/equipe/${professionalType}`);
                          }}
                          color="transparent"
                          className="btn btn-link text-decoration-underline"
                        >
                          Cancelar
                        </Button>

                        <Button
                          color="primary"
                          className="btn btn-primary"
                          type="submit"
                        >
                          Salvar
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardFooter> */}
              {/*  */}
            </Card>
          </Form>

          <Card className="p-3">
            <h4>Perfis Associados</h4>
            <div className="mt-3">
              <DataTable
                data={profilesAssociated}
                actions={[]}
                loading={profilesLoading}
                noDataBg={noDataBg}
                canSearch={false}
                columns={makeColumnsCoordinators(
                  handleActiveInactiveSwitchChangeProfile,
                )}
              />
            </div>
          </Card>
        </Col>
      </Row>
      {/* </Container> */}

      <ModalConfirmAction
        modalTheme="warning"
        featherIconName="alert-triangle"
        isOpen={isModalOpen}
        toggle={toggleModalActivateInactiveProfile}
        loading={false}
        title={`${profileStatus ? 'Ativar' : 'Inativar'} Perfil?`}
        subtitle={`Tem certeza que deseja ${profileStatus ? 'ativar' : 'inativar'} o perfil?`}
        actionBtnLabel={`${profileStatus ? 'Ativar' : 'Inativar'}`}
        onConfirm={() => {
          requestUpdateStatusAssociatePersonProfile({
            id: profileAssociateId!,
            status: profileStatus!,
            profileId: roleId,
          }).then(() => {
            toggleModalActivateInactiveProfile();
            setProfileStatus(null);
            setProfileId(null);
            // requestGetAllPersonProfile({ id });
          });
          /* requestActivateInactivatePersonProfile(
            {
              id: String(profileId),
              activeStatus: profileStatus,
            },
            () => {
              toggleModalActivateInactiveProfile();
              setProfileStatus(null);
              setProfileId(null);
              // requestGetAllPersonProfile({ id });
            },
          ); */
        }}
        onClosed={() => {
          setProfileId(null);
          setProfileStatus(null);
        }}
      />
    </div>
  );
};
